import createDefaultButtonsLine from './createDefaultButtonsLine';
import initCells from '../../cells';

export default function (instance, task) {
  let row = createDefaultButtonsLine(instance, task);

  row = initCells(instance, row, task);

  return row;
}
